// extracted by mini-css-extract-plugin
var _1 = "ChatroomInputFormSkeleton-moduleactions__fmDuC";
var _2 = "ChatroomInputFormSkeleton-moduleactionsSpacer__LDWAl";
var _3 = "ChatroomInputFormSkeleton-moduleavatar__DcQdc Skeleton-moduleSkeleton__Mlrfv";
var _4 = "ChatroomInputFormSkeleton-modulebody__NtyKL";
var _5 = "ChatroomInputFormSkeleton-modulechip__aDJXl Skeleton-moduleSkeleton__Mlrfv";
var _6 = "ChatroomInputFormSkeleton-modulechipWide__uCff5 Skeleton-moduleSkeleton__Mlrfv";
var _7 = "ChatroomInputFormSkeleton-moduleform__VaU7i";
var _8 = "ChatroomInputFormSkeleton-moduletemplateRow__RyMfA Skeleton-moduleSkeleton__Mlrfv";
var _9 = "ChatroomInputFormSkeleton-modulewysiwyg__oBTHq Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "actions", _2 as "actionsSpacer", _3 as "avatar", _4 as "body", _5 as "chip", _6 as "chipWide", _7 as "form", _8 as "templateRow", _9 as "wysiwyg" }
